

<template lang="pug">

span.animated-number {{ animatedNumber }}

</template>


<script>
import Vue from 'vue'
import lerp from 'lerp'

export default {
  name: 'animated-number',
  props: {
    number: {
      default: 0,
    },
    digits: {
      default: 2,
    },
    time: {
      default: 1000,
    },
  },
  data() {
    return {
      animatedNumber: 0,
    }
  },
  mounted() {
    Vue.nextTick(() => {
      this.animate(0, this.number)
    })
  },
  methods: {
    animate(from, to) {
      this.from = from
      this.to = to
      this.startTime = window.performance.now()
      this.rafId = window.requestAnimationFrame(this.update)
    },
    update() {
      const now = window.performance.now()
      const percent = (now - this.startTime) / this.time
      let num = lerp(this.from, this.to, percent)
      if (this.to > this.from) {
        num = Math.min(num, this.to)
      } else {
        num = Math.max(num, this.to)
      }
      num = num.toFixed(this.digits)
      this.animatedNumber = num

      if (percent >= 1) return

      this.rafId = window.requestAnimationFrame(this.update)
    },
  },
  beforeDestroy() {
    window.cancelAnimationFrame(this.rafId)
  },
  watch: {
    number(newVal, oldVal) {
      this.animate(oldVal, newVal)
    },
  },
}
</script>


<style lang="sass" scoped>
@import "src/styles/common.sass"

.animated-number

</style>
